import clsx from 'clsx'
import { FieldSet, Radio } from 'shared/ui'

import { STATUS_OPTIONS } from './const'
import css from './Filters.module.css'

export const AccountStatus = ({ initial = false }: { initial?: boolean }) => (
	<FieldSet
		className={clsx(css.set, css.status, css.start)}
		key={Number(initial)}
		legend='Account Status'
		legendCN={clsx(css.label, css.label)}
		level='h5'
	>
		{STATUS_OPTIONS.map(({ label, value }) => (
			<label className={css.radio} key={label}>
				<Radio
					defaultChecked={initial ? Boolean(value) : !value}
					name='status'
					value={value}
				/>
				{label}
			</label>
		))}
	</FieldSet>
)
